(function() {
    'use strict';

    angular.module('order')
        .controller('OrderNegotiateModalController', OrderNegotiateModalController);

    OrderNegotiateModalController.$inject = ['lodashService', 'orderDataSrvc', 'notificationSrvc', 'errorNotificationSrvc', 'orderNegotiationsMessagesConst', '$uibModalInstance', 'order'];

    function OrderNegotiateModalController(lodashService, orderDataSrvc, notificationSrvc, errorNotificationSrvc, orderNegotiationsMessagesConst, $uibModalInstance, order) {
        var self = this;

        self.order = order;
        self.server_errors = {};
        self.ok = ok;
        self.negotiate = negotiate;
        self.reject = reject;

        activate();

        function activate() {}

        function ok() {
            self.order = null;
            $uibModalInstance.dismiss('cancel');
        }

        function negotiate() {
            orderDataSrvc.negotiate({
                pk: order.pk
            }, {
                negotiated_discount: order.negotiated_discount,
                negotiated: true
            }).$promise.then(
                function (response) {
                    notificationSrvc.notification('success', orderNegotiationsMessagesConst.negotiationsApproved);
                    $uibModalInstance.close();
                },
                function (response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            )
        }

        function reject() {
            orderDataSrvc.negotiate({
                pk: order.pk
            }, {
                negotiated: false
            }).$promise.then(
                function (response) {
                    notificationSrvc.notification('success', orderNegotiationsMessagesConst.negotiationsDeclined);
                    $uibModalInstance.close();
                },
                function (response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            )
        }
    }
})();
